import React, { useState, useEffect } from "react";
import '../../css/bg.css'
import { safeRequestIdleCallback } from "../../Utils/requestIdleCallbackPolyfill";

function Background() {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    safeRequestIdleCallback(() => setAnimate(true), { timeout: 2000 });
  }, []);

    return (
        <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className={`wave w-full h-64 absolute bg-blue-300 ${animate ? 'animate' : ''}`}></div>
          <div className={`wave w-full h-64 absolute bg-green-300 ${animate ? 'animate' : ''}`}></div>
          <div className={`wave w-full h-64 absolute bg-teal-300 ${animate ? 'animate' : ''}`}></div>
        </div>
      </div>
    );
}

export default Background;
